import styled from "styled-components";
import { FontKey, fonts } from "../../style/fonts";

export const Text = styled.p<{fontStyle?: FontKey}>(props => {
  if (props.fontStyle) {
    return fonts[props.fontStyle];
  }

  return fonts.Body;
});